<template>
    <div>
        <div class="row no-gutters">
            <div class="col-12">
                <h2 class="order-summary__head">
                    {{ getTranslation('order-content', translate, {'name': product.name }) }}
                </h2>
            </div>
        </div>

        <div class="custom-table">
            <div class="row custom-table__head d-none d-sm-flex">
                <div class="col-6"><div class="custom-table__head--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'quantity') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'price') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'total') }}</div></div>
            </div>
            <div class="row no-gutters custom-table__body">
                <template v-for="program in sortedPrograms()" v-if="program.product == product.id && program[licenceType] > 0">
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm-6">
                        <div class="custom-table__body--elem" v-html="programName(program)"></div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'quantity') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ quantity(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ linePrice(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ totalPrice(program) }}</div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                </template>
            </div>
        </div>
        <br><br>
    </div>

</template>

<script>
    export default {
        methods: {
            sortedPrograms() {
                return  _.sortBy(this.programs, [function(o) { return o.sortOrder; }]).reverse();
            },
            quantity(program) {
                if (this.product.purchase_options.special_price == 'truss4') {
                    return 1;
                }
                return _.isNil(program[this.licenceType]) ? 0 : program[this.licenceType]
            },
            linePrice(program) {
                if (this.product.purchase_options.special_price == 'truss4') {
                    return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, program[this.licenceType]), true)
                }
                return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, 1, false, 0, program.days), true)
            },
            totalPrice(program) {
                if (this.product.purchase_options.special_price == 'truss4') {
                    return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, program[this.licenceType]), true)
                }
                return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, program[this.licenceType], false, 0, program.days), true)
            },
            programName(program) {
                if (this.product.purchase_options.special_price == 'truss4') {
                    return this.getPluralTranslation('cart-vue', 'program_name_with_qty_truss4_plural', program[this.licenceType], {name: program.name});
                }
                let name = program.name;
                if (program.days) {
                    name += " " + this.getFormattedDate(this.addDaysToToday(program.days));
                    name +=  " ( " + this.getPluralTranslation('order-content', 'days_with_plural', program.days) +" ) "
                }
                return name;
            },
            addDaysToToday(days) {
                const date = new Date(); // Get today's date
                date.setDate(date.getDate() + days); // Add the specified number of days
                return date; // Returns the new date object
            },
            getFormattedDate(date = false) {
                if (date === false) {
                    date = new Date();
                }
                let year = date.getFullYear();
                // Month is 0-indexed, so add 1
                let month = String(date.getMonth() + 1).padStart(2, '0');
                let day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
        },
        computed: {

        },
        data() {
            return {
                products: window.jsonProducts,
                programs: this.$store.state.cart.programs
            };
        },
        props: {
            product: Object,
            licenceType: String,
            translate: String
        }
    }
</script>
